import { QueryFunctionContext } from "@tanstack/react-query";
import { PreOrderDetailsModel, PreOrderModel } from "./Models";
import { PreOrderUpdateStatusModel } from "./Models";
import ApiHttpClient from "@/HttpClient";

export interface PreOrdersListResponse {
  totalCount: number;
  totalPages: number;
  pageNumber: number;
  pageSize: number;
  items: PreOrderModel[]
}

export interface PreOrderDetailsListResponse {
  totalCount: number;
  totalPages: number;
  pageNumber: number;
  pageSize: number;
  items: PreOrderDetailsModel[]
}

export interface PreOrderResponse extends PreOrderModel { }

type PatchResponse = PreOrderUpdateStatusModel;

export const fetchPreOrders = async ({ queryKey }: QueryFunctionContext) => {
  const [, pageNumber, pageSize] = queryKey;

  const { data, status, statusText } = await
    ApiHttpClient().post<PreOrdersListResponse>(`/preOrder/search`, {
      "keyword": "",
      "pageNumber": pageNumber,
      "pageSize": pageSize,
    });
  if (!data) throw new Error(`Did not receive a response, status ${status} ${statusText}`);
  return data;
}

export const fetchPreOrder = async ({ queryKey }: QueryFunctionContext) => {
  const [, preOrderId] = queryKey;
  const {data, status, statusText} = await ApiHttpClient().get<PreOrderResponse>(`/preOrder/${preOrderId}`);

  console.log(`Status ${status} ${statusText}`);
  console.log(JSON.stringify(data, null, 4));
  return data;
}

export const updatePreOrderStatus = async (preOrderId: number, documentStatusId: number): Promise<PatchResponse> => {
  const response = await ApiHttpClient().patch<PatchResponse>(`/preOrder`, {
    "id": preOrderId,
    "documentStatusId": documentStatusId
  });
  return response.data;
}


export const fetchPreOrderWithDetails = async ({ queryKey }: QueryFunctionContext) => {
  const [, preOrderId, pageNumber, pageSize] = queryKey;

  const { data, status, statusText } = await ApiHttpClient().get<PreOrderDetailsListResponse>(`/preOrderDetail/PreOrderId/${preOrderId}`, {
    params: {
      pageNumber,
      pageSize,
    }
  })

  if (!data) throw new Error(`Did not receive a response, status ${status} ${statusText}`);
  return data;
}